import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { menuCategoriesActions } from "../../../../store/slices/settings-slices";
import css from "../../../dishesSection/dishesSectionModals/DishRightBlockInfoModal/DishRightBlockInfoModal.module.css";
import { DishRightBlockSingleNumberReusModal } from "../../../dishesSection/dishesSectionModals/DishRightBlockSingleNumberReusModal/DishRightBlockSingleNumberReusModal";
import { getConfig } from "../../../../config";

const SemiFinishedRightBlockInfoModal = ({
  selectedCategory,
  setSelectedCategory,
  handleCategoryChange,
}) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { cityCode } = getConfig();
  const { menuCategories, trigger } = useSelector(
    (store) => store.menuCategories
  );

  const {
    register,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    dispatch(menuCategoriesActions.getAllMenuCategories());
  }, [trigger]);

  return (
    <div className={css.wrap}>
      <div className={css.inputGroup}>
        <label htmlFor="group">Group</label>
        <select
          id="group"
          value={selectedCategory}
          onChange={handleCategoryChange}
          className={css.select}
        >
          <option value=""> </option>
          {menuCategories &&
            menuCategories.map((obj) => (
              <option key={obj.id} value={obj.id}>
                {obj.name[currentLanguage] || obj.name["en"]}
              </option>
            ))}
        </select>
      </div>

      {errors.nameEn && <p className={css.error}>{errors.nameEn.message}</p>}
      <div className={css.inputGroup}>
        <label htmlFor="nameEn">
          {t("modal-name-input-new-category")} (English)
        </label>
        <input
          type="text"
          id="nameEn"
          {...register("nameEn", { required: "This field is required" })}
        />
      </div>

      {errors.nameRu && <p className={css.error}>{errors.nameRu.message}</p>}
      <div className={css.inputGroup}>
        <label htmlFor="nameRu">
          {t("modal-name-input-new-category")} (Русский)
        </label>
        <input
          type="text"
          id="nameRu"
          {...register("nameRu", { required: "This field is required" })}
        />
      </div>

      {cityCode === "UAE" ? (
        <>
          {errors.nameAr && (
            <p className={css.error}>{errors.nameAr.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="nameAr">
              {t("modal-name-input-new-category")} (العربية)
            </label>
            <input
              type="text"
              id="nameAr"
              {...register("nameAr", { required: "This field is required" })}
            />
          </div>
        </>
      ) : (
        <>
          {errors.nameKa && (
            <p className={css.error}>{errors.nameKa.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="nameKa">
              {t("modal-name-input-new-category")} (ქართული)
            </label>
            <input
              type="text"
              id="nameKa"
              {...register("nameKa", { required: "This field is required" })}
            />
          </div>
        </>
      )}

      <div className={css.inputGroup}>
        <label htmlFor="descriptionEn">
          {t("modal-Description-input")} (English)
        </label>
        <input type="text" id="descriptionEn" {...register("descriptionEn")} />
      </div>

      <div className={css.inputGroup}>
        <label htmlFor="descriptionRu">
          {t("modal-Description-input")} (Русский)
        </label>
        <input type="text" id="descriptionRu" {...register("descriptionRu")} />
      </div>

      {cityCode === "UAE" ? (
        <>
          <div className={css.inputGroup}>
            <label htmlFor="descriptionAr">
              {t("modal-Description-input")} (العربية)
            </label>
            <input
              type="text"
              id="descriptionAr"
              {...register("descriptionAr")}
            />
          </div>
        </>
      ) : (
        <>
          <div className={css.inputGroup}>
            <label htmlFor="descriptionKa">
              {t("modal-Description-input")} (ქართული)
            </label>
            <input
              type="text"
              id="descriptionKa"
              {...register("descriptionKa")}
            />
          </div>
        </>
      )}

      <div className={css.numbersBlock}>
        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-energy")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-proteins")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-fats")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-carbohydrates")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("Cost")}
          overrideLabel={t("override")}
        />
      </div>
    </div>
  );
};

export { SemiFinishedRightBlockInfoModal };
